<template>
<div>
  <v-row
    class="pt-2"
    style="text-align: left;width:100%;max-width:300px;"
    :style="{ 
      'padding': !isSimulation && isDesktop ? '15px 30px 15px 30px' : '0',
    }"
  >
    <v-col cols="2" style="text-align:right;">
      <v-icon
        :style="{ 'color': customTextColorContent ? customTextColorContent : ColorContent }"
        v-if="data.ContactIcon && data.ContactIcon.length > 0"
      >
        {{data.ContactIcon}}
      </v-icon>
    </v-col>
    <v-col style="text-align: left;">
      <span
        v-if="data.ContactIcon === 'mdi-whatsapp'"
        :style="{ 'color': customTextColorContent ? customTextColorContent : ColorContent,
          'font-size': `${FontSizeContent}px`,
          'font-family': FontContent,
        }"
      ><a :href="`https://wa.me/${url && url.length > 0 ? url : description}`"
        style="text-decoration: none;"
        :style="{ 'color':customTextColorContent ? customTextColorContent :  ColorContent }"
      >{{description}}</a>        
      </span>
      <span
        v-else-if="data.ContactIcon === 'mdi-phone'"
        :style="{ 'color': customTextColorContent ? customTextColorContent : ColorContent,
          'font-size': `${FontSizeContent}px`,
          'font-family': FontContent,
        }"
      ><a :href="`tel:${url && url.length > 0 ? url : description}`"
        style="text-decoration: none;"
        :style="{ 'color': customTextColorContent ? customTextColorContent : ColorContent }"
      >{{description}}</a>        
      </span>
      <span
        v-else-if="data.ContactIcon === 'mdi-email'"
        :style="{ 'color': customTextColorContent ? customTextColorContent : ColorContent,
          'font-size': `${FontSizeContent}px`,
          'font-family': FontContent,
        }"
      ><a :href="`mailto:${url && url.length > 0 ? url : description}`"
        style="text-decoration: none;"
        :style="{ 'color': customTextColorContent ? customTextColorContent : ColorContent }"
      >{{description}}</a>        
      </span>
      <span
        v-else-if="['mdi-web', 'mdi-youtube', 'mdi-twitter','mdi-facebook', 'mdi-linkedin','mdi-instagram'].indexOf(data.ContactIcon) >= 0"
        :style="{ 'color': customTextColorContent ? customTextColorContent : ColorContent,
          'font-size': `${FontSizeContent}px`,
          'font-family': FontContent,
        }"
      ><a :href="`${url && url.length > 0 ? url : description}`"
        target="_blank"
        style="text-decoration: none;"
        :style="{ 'color': customTextColorContent ? customTextColorContent : ColorContent }"
      >{{description}}</a>        
      </span>
      <span
        v-else-if="['mdi-map-marker'].indexOf(data.ContactIcon) >= 0 && data.ContactLatLon && data.ContactLatLon.Lat && data.ContactLatLon.Lon"
        :style="{ 'color': customTextColorContent ? customTextColorContent : ColorContent,
          'font-size': `${FontSizeContent}px`,
          'font-family': FontContent,
        }"
      >
        <a :href="`${coordenates}`"
          target="_blank"
          style="text-decoration: none;"
          :style="{ 'color': customTextColorContent ? customTextColorContent : ColorContent }"
        >{{description}}</a>  
      </span>
      <span
        v-else
        :style="{ 'color': customTextColorContent ? customTextColorContent : ColorContent,
          'font-size': `${FontSizeContent}px`,
          'font-family': FontContent,
        }"
      >
        {{description}}
      </span>
    </v-col>
  </v-row>
<!--div v-else-if="isForceMobile"
>
  <v-layout wrap
  >
    <v-flex xs2>
      <v-icon
        :style="{ 'color': customTextColorContent ? customTextColorContent : ColorContent }"
        v-if="data.ContactIcon && data.ContactIcon.length > 0"
      >
        {{data.ContactIcon}}
      </v-icon>
    </v-flex>
    <v-flex xs10 style="">
      <span
        v-if="data.ContactIcon === 'mdi-whatsapp'"
        :style="{ 'color': customTextColorContent ? customTextColorContent : ColorContent,
          'font-size': `${FontSizeContent}px`,
          'font-family': FontContent,
        }"
      ><a :href="`https://wa.me/${url && url.length > 0 ? url : description}`"
        style="text-decoration: none;"
        :style="{ 'color': customTextColorContent ? customTextColorContent : ColorContent }"
      >{{description}}</a>        
      </span>
      <span
        v-else-if="data.ContactIcon === 'mdi-phone'"
        :style="{ 'color': customTextColorContent ? customTextColorContent : ColorContent,
          'font-size': `${FontSizeContent}px`,
          'font-family': FontContent,
        }"
      ><a :href="`tel:${url && url.length > 0 ? url : description}`"
        style="text-decoration: none;"
        :style="{ 'color': customTextColorContent ? customTextColorContent : ColorContent }"
      >{{description}}</a>        
      </span>
      <span
        v-else-if="data.ContactIcon === 'mdi-email'"
        :style="{ 'color': customTextColorContent ? customTextColorContent : ColorContent,
          'font-size': `${FontSizeContent}px`,
          'font-family': FontContent,
        }"
      ><a :href="`mailto:${url && url.length > 0 ? url : description}`"
        style="text-decoration: none;"
        :style="{ 'color': customTextColorContent ? customTextColorContent : ColorContent }"
      >{{description}}</a>        
      </span>
      <span
        v-else-if="['mdi-web', 'mdi-youtube', 'mdi-twitter','mdi-facebook', 'mdi-linkedin','mdi-instagram'].indexOf(data.ContactIcon) >= 0"
        :style="{ 'color': customTextColorContent ? customTextColorContent : ColorContent,
          'font-size': `${FontSizeContent}px`,
          'font-family': FontContent,
        }"
      ><a :href="`${url && url.length > 0 ? url : description}`"
        target="_blank"
        style="text-decoration: none;"
        :style="{ 'color': customTextColorContent ? customTextColorContent : ColorContent }"
      >{{description}}</a>        
      </span>
      <span
        v-else-if="['mdi-map-marker'].indexOf(data.ContactIcon) >= 0 && data.ContactLatLon && data.ContactLatLon.Lat && data.ContactLatLon.Lon"
        :style="{ 'color': customTextColorContent ? customTextColorContent : ColorContent,
          'font-size': `${FontSizeContent}px`,
          'font-family': FontContent,
        }"
      >
        <a :href="`${coordenates}`"
          target="_blank"
          style="text-decoration: none;"
          :style="{ 'color': customTextColorContent ? customTextColorContent : ColorContent }"
        >{{description}}</a>  
      </span>
      <span
        v-else
        :style="{ 'color': customTextColorContent ? customTextColorContent : ColorContent,
          'font-size': `${FontSizeContent}px`,
          'font-family': FontContent,
        }"
      >
        {{description}}
      </span>
    </v-flex>
  </v-layout>
</div-->
</div>
</template>

 <script>
  import {
    mapState
  } from 'vuex'
  import utils from '@/services/utils'
  import constants from '@/constants'
  export default {
    props: {
      data: {
        type: Object,
        required: true,
        default: null
      },
      customTextColorContent : {
        type: String,
        default: null,
      },
    },
    computed: {
      ...mapState('app',['locale', 'FontContent', 'FontSizeContent', 'ColorContent']),
      isForceMobile () {
        return this.$route.query.fm === 'true'
      },
      description () {
        return utils.getTranslation (this.data.ContactDescription, this.locale)
      },
      url () {
        return this.data.ContactURL ? utils.getTranslation (this.data.ContactURL, this.locale) : ''
      },
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      isDesktop() {
        return !utils.isMobile()
      },
      coordenates () {
        return `https://maps.google.com/?q=${this.data.ContactLatLon.Lat}%2C${this.data.ContactLatLon.Lon}`
      }
    },
  }
</script>
